import React from 'react'
import PropTypes from 'prop-types'
import { Box } from 'rebass'
import theme from '../../theme'

export const Radio = ({ color = theme.colors.red, handleClick }) => ( // eslint-disable-line
  <Box as="span" onClick={handleClick}>
    <svg fill={color} viewBox="0 0 24 24">
      <path fill="none" d="M0 0h24v24H0V0z" />
      <path d="M20 6H8.3l8.26-3.34L15.88 1 3.24 6.15C2.51 6.43 2 7.17 2 8v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8c0-1.11-.89-2-2-2zm0 2v3h-2V9h-2v2H4V8h16zM4 20v-7h16v7H4z" />
      <circle cx="8" cy="16.48" r="2.5" />
    </svg>
  </Box>
)

export const Facebook = () => (
  <svg viewBox="0 0 24 24">
    <path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2zm0-2C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm-2 10H8v2h2v6h3v-6h1.82l.18-2h-2v-.833c0-.478.096-.667.558-.667H15V6h-2.404C10.798 6 10 6.792 10 8.308V10z" />
  </svg>
)

export const Instagram = () => (
  <svg viewBox="0 0 24 24">
    <path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2zm0-2C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 7.082c1.602 0 1.792.006 2.425.035 1.627.074 2.385.845 2.46 2.459.028.633.034.822.034 2.424s-.006 1.792-.034 2.424c-.075 1.613-.832 2.386-2.46 2.46-.633.028-.822.035-2.425.035-1.602 0-1.792-.006-2.424-.035-1.63-.075-2.385-.849-2.46-2.46-.028-.632-.035-.822-.035-2.424s.007-1.792.035-2.424c.074-1.615.832-2.386 2.46-2.46.632-.029.822-.034 2.424-.034zM12 6c-1.63 0-1.833.007-2.474.037-2.18.1-3.39 1.309-3.49 3.489C6.007 10.167 6 10.371 6 12c0 1.63.007 1.834.036 2.474.1 2.179 1.31 3.39 3.49 3.49.641.029.844.036 2.474.036 1.63 0 1.834-.007 2.475-.036 2.176-.1 3.391-1.309 3.489-3.49.029-.64.036-.844.036-2.474 0-1.629-.007-1.833-.036-2.474-.098-2.177-1.309-3.39-3.489-3.489C13.834 6.007 13.63 6 12 6zm0 2.919a3.081 3.081 0 1 0 0 6.162 3.081 3.081 0 0 0 0-6.162zM12 14a2 2 0 1 1 0-4 2 2 0 1 1 0 4zm3.202-5.922a.72.72 0 1 0 0 1.44.72.72 0 0 0 0-1.44z" />
  </svg>
)

export const Icon = ({ icon: Icon }) => ( // eslint-disable-line
  <Box mr={2} width="30px">
    <Box as="span" css={{ fill: theme.colors.red }}>
      <Icon />
    </Box>
  </Box>
)

Icon.propTypes = {
  icon: PropTypes.node.isRequired,
}
export const IconWithLink = ({ link, icon: I }) => (
  <Box mr={2} width="30px">
    <a css={{ fill: theme.colors.red }} href={link} target="_blank" rel="noopener noreferrer">
      <Box as="span" css={{ fill: theme.colors.red }}>
        <I />
      </Box>
    </a>
  </Box>
)
IconWithLink.propTypes = {
  link: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
}
